import { Drawer, Stack, Theme } from "@mui/material";
import { FC } from "react";
import { InfrastructureArchitectureRecommendationDrawerDocDrawerHeader } from "./InfrastructureArchitectureRecommendationDrawerDocDrawerHeader";
import { usePanelHorizontalResize } from "@/components/utils/hooks/usePanelHorizontalResize";
import { ResourceDetailsDragHandler } from "@/components/pages/common/resource-details/components/ResourceDetailsDragHandler";
import { useAppSelector } from "@/store/hooks";
import { infrastructureArchitectureRecommendationDocSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRecommendationDocSelector";
import { anomaliesHtmlStyle } from "@/components/common/explain-with-ai-drawer/components/body/components/utils/constants";

interface InfrastructureArchitectureRecommendationDrawerDocDrawerProps {
  open: boolean;
  closeDialog(): void;
}

export const InfrastructureArchitectureRecommendationDrawerDocDrawer: FC<
  InfrastructureArchitectureRecommendationDrawerDocDrawerProps
> = ({ open, closeDialog }) => {
  const { width, handleMouseDown } = usePanelHorizontalResize(
    resizingDefaultParams,
  );
  const doc = useAppSelector(
    infrastructureArchitectureRecommendationDocSelector,
  );

  return (
    <Drawer
      anchor="right"
      open={open}
      variant={open ? "permanent" : undefined}
      PaperProps={{
        sx: {
          width,
          ...paperPropsStyles,
        },
      }}
    >
      <ResourceDetailsDragHandler
        onMouseDown={handleMouseDown}
        placement="left"
      />

      <Stack height="100dvh">
        <InfrastructureArchitectureRecommendationDrawerDocDrawerHeader
          closeDialog={closeDialog}
        />

        {doc && (
          <Stack
            px={3}
            sx={{
              ...anomaliesHtmlStyle,
              overflowY: "auto",
              overflowX: "hidden",
            }}
            dangerouslySetInnerHTML={{ __html: doc ?? "" }}
          />
        )}
      </Stack>
    </Drawer>
  );
};

const resizingDefaultParams = {
  defaultWidthPercent: 50,
  minWidthPercent: 40,
  maxWidthPercent: 80,
  key: "InfrastructureArchitectureRecommendationDrawerDocDrawer",
};

const paperPropsStyles = {
  height: "100vh",
  overflow: "hidden",
  boxShadow: "none",
  zIndex: (theme: Theme) => theme.zIndex.drawer - 10,
};
